import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const EditorAuthContext = createContext(null);
const KEY = "hh_editor_token";

export function EditorAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const getToken = () => localStorage.getItem(KEY);
  const authAxios = () => {
    const t = getToken();
    return axios.create({ baseURL: API, headers: t ? { Authorization: `Bearer ${t}` } : {} });
  };

  useEffect(() => {
    const t = getToken();
    if (!t) { setLoading(false); return; }
    authAxios().get("/editor/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem(KEY)).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/editor/login`, { email, password });
    localStorage.setItem(KEY, res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => { localStorage.removeItem(KEY); setUser(null); };

  return (
    <EditorAuthContext.Provider value={{ user, loading, login, logout, authAxios }}>
      {children}
    </EditorAuthContext.Provider>
  );
}

export const useEditorAuth = () => useContext(EditorAuthContext) || { user: null, loading: false, login: async () => {}, logout: () => {}, authAxios: () => axios.create({ baseURL: API }) };
